import useInView from "../hooks/useInView";

/**
 * RevealOnScroll — wrap any block to fade-up when scrolled into view.
 *
 * Props:
 *   delay:    ms offset for stagger (default 0)
 *   as:       element type, default "div"
 *   className: pass-through
 */
const RevealOnScroll = ({
  children,
  delay = 0,
  as: Tag = "div",
  className = "",
  ...rest
}) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        opacity:   inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(28px)",
        transition: `opacity 0.9s cubic-bezier(0.22,1,0.36,1) ${delay}ms, transform 0.9s cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
        willChange: "opacity, transform",
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default RevealOnScroll;
